import './Hud.scss';
import CesiumContainer from './CesiumContainer';

const Hud = () => {
    return (
        <div className='gs__hud'>
            <CesiumContainer />
        </div>
    );
};

export default Hud;
